import { render, staticRenderFns } from "./ContestRow.vue?vue&type=template&id=41a5fa6e&scoped=true"
import script from "./ContestRow.vue?vue&type=script&lang=ts"
export * from "./ContestRow.vue?vue&type=script&lang=ts"
import style0 from "./ContestRow.vue?vue&type=style&index=0&id=41a5fa6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a5fa6e",
  null
  
)

export default component.exports